import { Toast } from "@sscs/ui";
import { TokenDigest } from "Types";
import { apiErrorToast } from "Utils";
import { useRevokePersonalAccessTokenMutation } from "../services/personalAccessTokens.api";

type UseRevokeAccessToken = {
  handleRevokeAccessToken: () => void;
};

type UseRevokeAccessTokenProps = {
  tokenDigest: TokenDigest;
  userId?: string;
  successMessage: string;
  errorMessage: string;
};

const useRevokeAccessToken = ({
  tokenDigest,
  userId,
  successMessage,
  errorMessage,
}: UseRevokeAccessTokenProps): UseRevokeAccessToken => {
  const [revokeAccessToken] = useRevokePersonalAccessTokenMutation();

  const handleRevokeAccessToken = async () => {
    try {
      if (userId) {
        await revokeAccessToken({
          userId,
          tokenDigest,
        }).unwrap();
      }
    } catch (error) {
      apiErrorToast(error, errorMessage);
    }

    Toast.show({
      title: successMessage,
      type: "success",
    });
  };

  return {
    handleRevokeAccessToken,
  };
};

export default useRevokeAccessToken;
